// PaymentDateDialog.js
// Dialog for selecting payment date when marking payroll as paid

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import heLocale from 'date-fns/locale/he';
import { format } from 'date-fns';
import MobileDialog from './MobileDialog';

const PaymentDateDialog = ({ open, onClose, submissionIds, totalAmount, count, isLoading, onConfirm }) => {
  const [paymentDate, setPaymentDate] = useState(new Date());

  const handleConfirm = () => {
    const dateStr = format(paymentDate, 'yyyy-MM-dd');
    onConfirm(dateStr);
  };

  return (
    <MobileDialog
      open={open}
      onClose={onClose}
      title="סימון כשולם"
      maxWidth="xs"
    >
      <Box sx={{ p: 2, direction: 'rtl' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {count} משכורות נבחרו בסכום כולל של ₪{parseFloat(totalAmount || 0).toLocaleString()}
        </Typography>

        <Typography variant="body2" sx={{ mb: 1 }}>
          בחר תאריך תשלום:
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={heLocale}>
          <DatePicker
            value={paymentDate}
            onChange={(newValue) => setPaymentDate(newValue || new Date())}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
              },
            }}
          />
        </LocalizationProvider>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          תנועת ההוצאה תיווצר בתאריך זה
        </Typography>

        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-start', mt: 3 }}>
          <Button
            variant="contained"
            color="success"
            onClick={handleConfirm}
            disabled={isLoading || !paymentDate}
            startIcon={isLoading ? <CircularProgress size={16} /> : null}
          >
            {isLoading ? 'מעדכן...' : 'אישור תשלום'}
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}
          >
            ביטול
          </Button>
        </Box>
      </Box>
    </MobileDialog>
  );
};

export default PaymentDateDialog;
